import { AxiosError } from 'axios';
import { generateQueryString, get } from '@/utils';
import { IFeedbackLog, IFeedbackLogQuery } from '../use-feedback/types';

type FeedbackLogsResponse = {
	items?: unknown[];
	pageNumber?: number;
	totalPages?: number;
	totalCount?: number;
	orderBy?: string | null;
	ascending?: boolean;
	hasPreviousPage?: boolean;
	hasNextPage?: boolean;
};

const normalizeFeedbackLog = (log: unknown): IFeedbackLog => {
	const rawLog = log as Record<string, any>;

	return {
		id: Number(rawLog.id || 0),
		feedbackId: Number(rawLog.feedbackId || 0),
		action: {
			id: Number(rawLog?.action?.id || 0),
			name: String(rawLog?.action?.name || '')
		},
		description: String(rawLog.description || ''),
		type: String(rawLog.type || ''),
		requestId: String(rawLog.requestId || ''),
		performedAt: String(rawLog.performedAt || ''),
		performedBy: rawLog.performedBy
			? {
					id: Number(rawLog.performedBy.id || 0),
					firstName: String(rawLog.performedBy.firstName || ''),
					lastName: String(rawLog.performedBy.lastName || '')
				}
			: undefined
	};
};

const buildLogsQuery = (
	query: IFeedbackLogQuery | undefined,
	page: number,
	items: number
): string =>
	generateQueryString({
		...query,
		PageNumber: page + 1,
		PageSize: items
	});

async function fetchFeedbackLogs(
	feedbackId: number | string,
	page: number,
	items: number,
	query: IFeedbackLogQuery | undefined,
	onResponse?: (page: number, items: number) => void
): Promise<IFeedbackLog[]> {
	try {
		const res = await get(
			`api/feedbacks/${feedbackId}/logs${buildLogsQuery(query, page, items)}`
		);
		const data = res.data as FeedbackLogsResponse;
		onResponse?.(data.totalPages || 1, data.totalCount || 0);
		return (data.items || []).map(normalizeFeedbackLog);
	} catch (e) {
		const error = e as AxiosError;
		const data = error.response?.data as { error: string };
		throw new Error(data?.error || 'Nu am reușit să accesăm istoricul feedbackului.');
	}
}

export { fetchFeedbackLogs };
